import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { Container, Card, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

const Blog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const postsCol = collection(db, 'posts');
        const postSnapshot = await getDocs(postsCol);
        const postsList = postSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setPosts(postsList);
      } catch (err) {
        console.error("Error fetching posts: ", err);
      }
    };
    fetchPosts();
  }, []);

  const getPostContentSnippet = (content) => {
    // Strip HTML tags and get plain text
    const plainText = content.replace(/<\/?[^>]+(>|$)/g, "");
    // Truncate to desired length
    return plainText.length > 100 ? plainText.substring(0, 100) + '...' : plainText;
};

  return (
    <Container className="mt-5 min-vh-100">
      <Row>
        <Col>
          <h1 className="mb-4">Blog</h1>
        </Col>
      </Row>
      <Row xs={1} md={2} className="g-4">
        {posts.map(post => (
          <Col key={post.id} className="mb-4">
            <Card className="h-100">
              <Card.Body >
                <Card.Title>{post.title}</Card.Title>
                <Card.Text dangerouslySetInnerHTML={{ __html: getPostContentSnippet(post.content) }} />
                <Link to={`/blog/${post.id}`}>
                  <Button variant="primary">Read More</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Blog;
